var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"bg"}),_c('Header'),_c('Auth-Popup',{ref:"auth"}),_vm._m(0),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"followBtn"}},[_c('script',{attrs:{"src":"https://platform.linkedin.com/in.js","type":"application/javascript"}},[_vm._v("\n      lang: en_US\n    ")]),_c('script',{attrs:{"type":"IN/FollowCompany","data-id":"14460031"}})])
}]

export { render, staticRenderFns }